module.exports = __webpack_public_path__ + "img/jet5_feature_02.a2baeefe.jpg";